import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readEntityPages, deleteEntityPage } from '../actions/entity.page';
import { readEntity } from '../actions/entity';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';
import { green } from '@ant-design/colors';
function EntityPages(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);
    const [websiteUrl, setWebsiteUrl] = useState(null);

    useEffect(() => {
        dispatch(readEntity(params.entityId)).then((response) => {
            const url = response.result.protocol + '://' + response.result.host + (response.result.path ? `/${response.result.path}` : '') + '/zh';
            setWebsiteUrl(url);
        });
    }, [dispatch, params.entityId]);

    const deleteEntityPageAction = (id) => {
        dispatch(deleteEntityPage(params.entityId, id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('entityPages.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('entityPages.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('entityPages.columns.status.enabled');
                } else {
                    return t('entityPages.columns.status.disabled');
                }
            }
        },
        {
            title: t('entityPages.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('entityPages.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button size="small" type="primary" href={`/entity/${params.entityId}/page/${record.id}`}>{t('entityPages.actions.edit')}</Button>
                {record.slug && <Button key="preview" size="small" style={{ backgroundColor: green[5] }} type="primary" href={websiteUrl + '/' + record.slug} target="_blank">{t('entityPage.actions.preview')}</Button>}
                <Popconfirm
                    title={t('entityPages.actions.delete-confirm')}
                    onConfirm={() => deleteEntityPageAction(record.id)}
                    okText={t('entityPages.actions.delete-ok')}
                    cancelText={t('entityPages.actions.delete-cancel')}
                >
                    <Button size="small" type="primary" danger>{t('entityPages.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readEntityPages(params.entityId)).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch, params.entityId]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate(`/entity/${params.entityId}/dashboard`)}
                        title={t('entityPages.title')}
                        subTitle={t('entityPages.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={`/entity/${params.entityId}/page`}>{t('entityPages.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        size='small'
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default EntityPages;